/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import useResetPassword from './useResetPassword';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserClock } from '@fortawesome/free-solid-svg-icons';
import InputField from '../../../_component/InputField';
import TestimonialSwiper from '../../../_component/TestimonialSwiper';
import { Spin } from 'antd';

export default (props) => {
  const {
    loading,
    formInputsError,
    showPassword,

    onInputChange,
    onSubmitClick,
    handleShowPassword,
    onSignUpClick,
    checkFieldError,
  } = useResetPassword(props);

  return (
    <div className="auth-box centered ">
      <div className="centered auth-box-left">
        <div className="auth-left-logo-box">
          <span className="auth-left-logo-icon">
            <FontAwesomeIcon icon={faUserClock} />
          </span>
          <span className="auth-left-logo-text">Contact <b>Clues</b></span>
        </div>
        <form className="centered auth-left-form" onSubmit={onSubmitClick}>
          <div className="auth-form-greet">
          <h2 className="auth-form-greet-welcome">Confirm your password. </h2>
          </div>
          <InputField
            id="password"
            type="password"
            placeholder="Password"
            onChange={(e) => onInputChange(e.target.value, 'password')}
            onBlur={(e) => checkFieldError(e.target.value, 'password')}
            error={formInputsError.password}
            showPassword={showPassword}
            handleShowPassword={handleShowPassword}
            formSubmitError={formInputsError.formSubmitError}
            containerClassName="containerClass"
            inputClassName="inputClass"
            iconClassName="iconClass"
            errorClassName="errorClass"
            fontIconClassName="fontIconClass"
          />
          <button className="auth-form-submit-btn mt-4" type="submit" value="Submit">
            {loading ? (
              <div className="w-full centered justify-center">
                <Spin size="small" />
              </div>
            ) : (
              'Submit'
            )}
          </button>

          <p className="auth-form-account">
            Don't have an account?{' '}
            <button onClick={onSignUpClick} className="auth-form-account-btn">
              Sign up for free
            </button>
          </p>
        </form>
      </div>
      <div className="auth-box-carousel centered">
        <TestimonialSwiper />
      </div>
    </div>
  );
};
